export const SET_ONBOARDING_TOOLTIP = 'setOnboardingTooltip';
export const COMPLETE_SSI_NOTIFICATION = 'completeSsiNotification';